export default class ColorFilter  extends PIXI.Filter{
  constructor(data) {
    const vertexShader = null
    const fragmentShader = [
      'varying vec2 vTextureCoord;',

      'uniform float thresholdSensitivity;',
      'uniform float smoothing;',
      'uniform vec3 colorToReplace;',
      'uniform sampler2D uSampler;',

      'void main() {',
      'vec4 textureColor = texture2D(uSampler, vTextureCoord);',

      'float maskY = 0.2989 * colorToReplace.r + 0.5866 * colorToReplace.g + 0.1145 * colorToReplace.b;',
      'float maskCr = 0.7132 * (colorToReplace.r - maskY);',
      'float maskCb = 0.5647 * (colorToReplace.b - maskY);',

      'float Y = 0.2989 * textureColor.r + 0.5866 * textureColor.g + 0.1145 * textureColor.b;',
      'float Cr = 0.7132 * (textureColor.r - Y);',
      'float Cb = 0.5647 * (textureColor.b - Y);',

      'float blendValue = smoothstep(thresholdSensitivity, thresholdSensitivity + smoothing, distance(vec2(Cr, Cb), vec2(maskCr, maskCb)));',
      'gl_FragColor = vec4(textureColor.rgb, textureColor.a * blendValue);',
      '}',
    ].join('\n')
    super(vertexShader, fragmentShader)
    this.uniforms.thresholdSensitivity = 0.43
    this.uniforms.smoothing = 0.11
    this.uniforms.colorToReplace = [0 / 255, 255 / 255, 0 / 255]

    this.folders =  game.gui.folders
    this.controllers =  game.gui.controllers
    this.folders.colorFilter = game.gui.addFolder(data.name)

    this.folders.colorFilter.add(this.uniforms, 'thresholdSensitivity', 0, 1).step(0.01).onChange((value) => {
      this.uniforms.thresholdSensitivity = value
    })

    this.folders.colorFilter.add(this.uniforms, 'smoothing', 0, 1).step(0.01).onChange((value) => {
      this.uniforms.smoothing = value
    })

  }

}
